function toPeriodDigits(period: number): string {
  return String(Math.trunc(period)).replace(/\D/g, '');
}

export function getBallColor(colorClass: string): string {
  switch (colorClass) {
    case 'red': return '#e74c3c';
    case 'blue': return '#3498db';
    case 'green': return '#27ae60';
    default: return '#999';
  }
}

export function formatPeriod(period: number): string {
  const digits = toPeriodDigits(period);
  if (!digits) {
    return '--';
  }
  if (digits.length > 4) {
    return `${digits.slice(0, 4)}年第${digits.slice(4)}期`;
  }
  return `第${digits}期`;
}

export function shortPeriod(period: number): string {
  const digits = toPeriodDigits(period);
  if (!digits) {
    return '--';
  }
  if (digits.length > 4) {
    return `${digits.slice(4)}期`;
  }
  return `${digits}期`;
}

export function splitDrawBalls<T>(
  balls: T[],
  regularCount?: number,
  specialCount?: number,
): { normalBalls: T[]; specialBalls: T[] } {
  const total = Array.isArray(balls) ? balls.length : 0;
  if (total === 0) {
    return { normalBalls: [], specialBalls: [] };
  }

  const safeRegularCount = Number.isInteger(regularCount) ? Math.max(0, Number(regularCount)) : undefined;
  const safeSpecialCount = Number.isInteger(specialCount) ? Math.max(0, Number(specialCount)) : undefined;

  if (safeSpecialCount !== undefined) {
    const clampedSpecialCount = Math.min(total, safeSpecialCount);
    const resolvedRegularCount = safeRegularCount !== undefined
      ? Math.min(total - clampedSpecialCount, safeRegularCount)
      : total - clampedSpecialCount;
    return {
      normalBalls: balls.slice(0, resolvedRegularCount),
      specialBalls: balls.slice(resolvedRegularCount, resolvedRegularCount + clampedSpecialCount),
    };
  }

  if (safeRegularCount !== undefined) {
    const clampedRegularCount = Math.min(total, safeRegularCount);
    return {
      normalBalls: balls.slice(0, clampedRegularCount),
      specialBalls: balls.slice(clampedRegularCount),
    };
  }

  if (total === 7) {
    return {
      normalBalls: balls.slice(0, 6),
      specialBalls: balls.slice(6),
    };
  }

  return { normalBalls: balls, specialBalls: [] };
}
